/* eslint-disable react/jsx-no-target-blank */
import React from "react";

const MENUS = [
	
	{
		name: "Company",
		items: [
			{
				name: "About 24Telemed",
				link: "https://24telemed.org/about",
				ext: true
			},
			{
				name: "Our Services",
				link: "https://24telemed.org/home#services",
				ext: true
			},
			{
				name: "Career",
				link: "https://24telemed.org/career",
				ext: true
			},
			{
				name: "FAQs",
				link: "https://24telemed.org/faq",
				ext: true
			},
			{
				name: "Contact",
				link: "https://24telemed.org/contact",
				ext: true
			}
		],
	},
	{
		name: "LINKS",
		items: [
			{
				name: "Register",
				link: "/register",
			},
			{
				name: "Sign In",
				link: "/login",
			}
		],
	},
	{
		name: "LEGAL",
		items: [
			{
				name: "Terms of Use",
				link: "https://24telemed.org/p/privacy-policy",
				ext: true
			},
			{
				name: "Privacy Policy",
				link: "https://24telemed.org/p/legal",
				ext: true
			},
			{
				name: "Cancellation Policy",
				link: "https://24telemed.org/p/cancellation-policy",
				ext: true
			},
			{
				name: "Legal",
				link: "https://24telemed.org/p/terms-of-services",
				ext: true
			}
		],
	},
];

const Footer = () => {
	return (
		<>
			<footer className="main-footer">
				<div className="container">
					<div className="columns footer-body pt-0">
						{/* Column */}
						<div className="column is-4">
							<div className="p-t-10 p-b-10">
								<img
									className="small-footer-logo"
									src={require("../../assets/images/logo.png").default}
									alt
								/>
								<div className="footer-description p-t-10 p-b-10">
								Relentlessly breaking down healthcare disparities in Rural Nigeria from project managements to full IT support
								</div>
							</div>
						</div>
						{/* Column */}
						<div className="column is-7 is-offset-1">
							<div className="columns is-flex-tablet-p">
								{/* Column */}
								{MENUS.map(({ name, items }) => {
									return (
										<div className="column">
											<ul className="footer-column">
												<li className="column-header">{name}</li>
												{items.map(({ name, link, ext }) => {
													return (
														<li className="column-item">
															<a href={link}
																target={ ext ? "_blank" : "_self" }
															>{name}</a>
														</li>
													);
												})}
											</ul>
										</div>
									);
								})}
							</div>
						</div>
					</div>
					<div className="footer-copyright">
						<p>
							© {new Date().getFullYear()} • <a href={'https://www.24telemed.org'}>24Telemed eHealth Services</a> | All
							Rights Reserved.
						</p>
						<div>
							<div className="social-links">
								<a href="#">
									<i data-feather="facebook" />
								</a>
								<a href="#">
									<i data-feather="twitter" />
								</a>
								<a href="#">
									<i data-feather="linkedin" />
								</a>
								<a href="#">
									<i data-feather="instagram" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</footer>
			<div 
				dangerouslySetInnerHTML={{ __html: `
				<div
				class="progress-wrap"
				  data-x-data="initBackToTop()"
				  data-x-init="setup()"
				  data-x-on:scroll.window="scroll()" data-x-bind:class="{
				  'active-progress': scrolled,
				  '': !scrolled,
				  }"
				  data-x-on:click="scrollTop()"
			>
				<svg
					class="progress-circle svg-content"
					width="100%"
					height="100%"
					viewBox="-1 -1 102 102"
				>
					<path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
				</svg>
			</div>
				` }}
			/>
			<div id="languages-modal" className="modal">
				<div className="modal-background modal-dismiss" />
				<div className="modal-content">
					{/*Modal card*/}
					<div className="card">
						<header className="card-header">
							<div className="card-header-title">
								<span>Select a language</span>
							</div>
							<button className="modal-dismiss">
								<span className="icon">
									<i data-feather="x" />
								</span>
							</button>
						</header>
						<div className="card-content">
							<div className="check-cards-group">
								{/*Card*/}
								<div className="check-card">
									<input
										type="radio"
										name="language_selection"
										defaultChecked
									/>
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/united-states-of-america.svg"
											alt
										/>
										<div className="meta">
											<span>English [US]</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/england.svg"
											alt
										/>
										<div className="meta">
											<span>English [UK]</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/france.svg"
											alt
										/>
										<div className="meta">
											<span>French [FR]</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/canada.svg"
											alt
										/>
										<div className="meta">
											<span>French [CA]</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/germany.svg"
											alt
										/>
										<div className="meta">
											<span>German</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/spain.svg"
											alt
										/>
										<div className="meta">
											<span>Spanish</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/portugal.svg"
											alt
										/>
										<div className="meta">
											<span>Portuguese</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/brazil.svg"
											alt
										/>
										<div className="meta">
											<span>Portuguese [BR]</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/china.svg"
											alt
										/>
										<div className="meta">
											<span>Chinese</span>
										</div>
									</div>
								</div>
								{/*Card*/}
								<div className="check-card">
									<input type="radio" name="language_selection" />
									<div className="check-card-inner">
										<img
											src="https://dummyimage.com/150x150"
											data-demo-src="img/icons/flags/thailand.svg"
											alt
										/>
										<div className="meta">
											<span>Thai</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Footer;
